let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4fCH6")).then(() => parcelRequire('k9BOK'));